
 import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AdminOnly',
})
export default class AdminOnly extends Vue {
  get isAdmin() {
    return this.$store.getters["user/isAdminUser"];
  }
  private render() {
    if (this.isAdmin) {
      return this.$slots.default;
    }
  }
}
